export default "__VITE_ASSET__o4DvTJ6$__"